(function ($) {
	$.vquipOverlay = function (element, options) {
		// **************************************************************
		// Public Properties
		// **************************************************************

		var $c = $(element), // Context 

			VquipOverlay = (function ($c, o) {
				var defaults = {
					'baseClass': 'module-overlay',
					'openClass': 'open',
				}; 

				var _o = {},
                    $bb = null, // Book Buttons
                    $if = null, // IFrame
					$oc = null, // Overlay Container
					$cc = null, // Content Container
					$cbtn = null // Close Button
				;

				var _InitObjects = function () {
					_o = $.extend({}, defaults, o);

                    // Look for triggers
                    $bb = $('.vquip-book-button');
					_BuildOverlay();
				},

                    _BuildOverlay = function() {
                        $oc = $('<div />')
                            .addClass(_o.baseClass + '__container')
                            .addClass('vquip-overlay')
                            .appendTo('body');

                        $cc = $('<div />')
                            .addClass(_o.baseClass + '__content')
                            .appendTo($oc);

                        $cbtn = $('<span />')
                            .addClass(_o.baseClass + '__close')
                            .appendTo($oc);

                                $cbt = $('<span />')
                                    .addClass(_o.baseClass + '__close--bar bar top')
                                    .appendTo($cbtn);
                                $cbb = $('<span />')
                                    .addClass(_o.baseClass + '__close--bar bar bot')
                                    .appendTo($cbtn);
                    },

				_BindEvents = function () {
					_BuildTimeline();

                    $bb.click(_OnTriggerClick);
					$cbtn.click(_OnCloseClick);
                },

                    _BuildTimeline = function() {
                        tln = new TimelineLite({ paused: true });
                        tln
                            .add('close')
                            .add(new TweenMax($cbt, 1, { css: { opacity: 1, rotation: 45 }, ease: Power4.easeInOut }), 'close')
                            .add(new TweenMax($cbb, 1, { css: { opacity: 1, rotation: -45 }, ease: Power4.easeInOut }), 'close')
                        ;
                    }

                    _OnTriggerClick = function(e) {
                        e.preventDefault();
                        var $$ = $(e.currentTarget),
                            bid = $$.data('book-id');

                        window.CLOSE_OVERLAY = (function() { this.click(); }).bind($cbtn);
                        $if = $('<iframe />')
                            .css('opacity', 10)
                            // .prop('src', 'https://www.scorpionbayaz.com/_overlays/closer/')
                            .prop('src', 'https://scorpionbayrentals.vquiprentals.com/reservations/'+bid)
                            .appendTo($cc);
                            
                        $oc.fadeIn(500, 'swing', function() {
							tln.play();
                            $if.fadeIn();
						});
                    },

					_OnCloseClick = function(e) {
						e.preventDefault();
						tln.reverse().timeScale(1.5);
						setTimeout(function() {
							$oc.fadeOut(500, function() {
                                $cc.empty();
                                $if = null;
                            });
						}, 500);
					},

				init = (function() {
					_InitObjects();
					_BindEvents();
				})();
			}) ($c, options);
	};

	$.fn.vquipOverlay = function (options) {
		return this.each(function () {
			if (undefined === $(this).data('vquipOverlay')) {
				var plugin = new $.vquipOverlay(this, options);
				$(this).data('vquipOverlay', plugin);
			}
		});
	};
})(jQuery);
